import { Wallet, WalletPatch } from '../types/wallet.types';
import { Filter, OrderByType, useGenericAPI, useSingleGenericAPI } from '../../../utils/genericAPI/useGenericAPI';
import { useAuth } from '../../auth/hooks';
import { appPayGoCreditAPI, BASE_URL_WALLETS } from '../services/walletsAPI';
import { useParams } from 'react-router-dom';
import useTransaction from './useTransaction';
import { useMutation } from 'react-query';


export const useWallets = (config?: {
  pageSize?: number;
  orderBy?: OrderByType<Wallet>;
  preFilters?: Filter<Partial<Wallet>>
}) => {
    const { setHeaderAuthToRequest } = useAuth();
    setHeaderAuthToRequest();

    const { getAllQuery, createNew: createNewWallet } = useGenericAPI<
        Wallet,
        WalletPatch,
        WalletPatch
    >({
        baseURL: BASE_URL_WALLETS,
        APIname: "wallets",
        pageSize: config?.pageSize,
        orderBy: config?.orderBy,
        preFilter: config?.preFilters,
   
    })

 

    return {
        allWalletsQuery: { ...getAllQuery },
        createNewWalletQuery: {
            ...createNewWallet,
        },
    };
}

export const useSingleWallet = (id?: string) => {
    const {walletId} = useParams<{ walletId: string }>();

    const idFound = id || walletId;

    const { setHeaderAuthToRequest } = useAuth();
    setHeaderAuthToRequest();

    const { singleQuery } = useSingleGenericAPI<Wallet, WalletPatch>({
        baseURL: BASE_URL_WALLETS,
        APIname: "wallets",
        id: idFound
    })

    const {getAllTransactionQuery, createNewTransactionQuery} = useTransaction({walletId: idFound, orderBy: "-w_transaction_created_at", pageSize:10});

    const addPayGoCreditQuery = useMutation({
        mutationFn: async ({ paygoToken, stationSlug }: { paygoToken: string; stationSlug: string }) => {
            return appPayGoCreditAPI({
                walletId: idFound || "",
                paygoToken,
                stationSlug
            })
        }
    })
    return {
        singleWalletQuery: singleQuery,
        allTransactionQuery: getAllTransactionQuery,
        createNewTransactionQuery,
        walletId: idFound,
        addPayGoCreditQuery
    }
}